// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"60":"03edf9ff","115":"f13a52ca","202":"da8f7186","264":"f11f0ce7","467":"5131eb1a","557":"94e7bcc2","585":"bafb452d","595":"023488e5","596":"12fd5522","722":"561eaec8","757":"923a6751","878":"5a66c795","895":"82ddd34a","919":"4df5f9e5","970":"69115af7"}[chunkId] + ".chunk.js";
};